/* eslint-disable react-hooks/exhaustive-deps */
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CreateIcon from "@mui/icons-material/Create";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import Axios from "axios";
import DeleteButton from "main/components/DeleteButton/DeleteButton";
import { getErrorMsg, showToast } from "main/shared/helpers";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  deleteObservation,
  deleteObservationRoom,
  getRoomObservation,
  orderObservations,
} from "../../../../../services/ObservationService";
import "../../style.css";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { debounce } from "lodash";

// SortableObservation component for drag-and-drop observations
function SortableObservation({
  observation,
  index,
  active,
  onEditObservation,
  handleDeleteObservation,
  setActive,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: observation.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      key={`observation-${index}`}
      className={`liststyle d-flex${index === active ? " listActive" : ""}`}
      onClick={() => {
        setActive(index);
      }}
    >
      <div
        {...listeners}
        style={{
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          marginRight: "8px",
          color: "#74b44a",
          padding: "0 4px",
        }}
      >
        <DragHandleIcon fontSize="small" />
      </div>
      <span style={{ flex: 1 }}>
        #{observation.code} - {observation.location}
      </span>
      <div
        style={{
          marginLeft: "auto",
          padding: "0 6px",
          color: "#84857A",
          display: "flex",
          alignItems: "center",
          minWidth: "65px",
        }}
      >
        <CreateIcon onClick={() => onEditObservation(observation)} />
        <DeleteButton
          deleteFunction={handleDeleteObservation(observation.id)}
          message={"Are you sure you want to delete this observation?"}
        />
      </div>
    </li>
  );
}

export default function ObservationSubList({
  name,
  selectedRoomId,
  onOpen,
  setSelectedObservation,
  setSelectedObservationId,
  openAddObservationModal,
  roomId,
  refreshSubList,
  refreshRoomList,
  setEditObservation,
  onEditRoom,
  dragListeners,
  isDragging,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [active, setActive] = useState(0);
  const [observations, setObservations] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [noData, setNoData] = useState(false);
  const source = Axios.CancelToken.source();
  const [refresh, setRefresh] = useState(false);
  const [hovered, setHovered] = useState(false);

  // DnD Kit sensors for observations
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  // Debounced API call to save observation order
  const debouncedOrderObservations = React.useRef(
    debounce((orderedObservations, roomId) => {
      const observation_id = orderedObservations.map((o) => o.id);
      const order_sequence = orderedObservations.map((_, idx) => idx + 1);
      const payload = {
        room_id: roomId,
        observation_id,
        order_sequence,
      };
      orderObservations(payload)
        .then(() => {
          showToast("Observation order saved successfully", true);
        })
        .catch((err) => {
          showToast(getErrorMsg(err) || "Error saving observation order");
        });
    }, 1000)
  ).current;

  useEffect(() => {
    if (isOpen) {
      getObservations(roomId, page);
    } else {
      source.cancel();
      setLastPage(1);
      setObservations([]);
      setNoData(false);
      setActive(0);
    }
  }, [isOpen, page, refreshSubList, refresh]);

  useEffect(() => {
    console.log("refreshSublist", refreshSubList);
  }, [refreshSubList]);

  useEffect(() => {
    if (observations.length > 0) {
      setSelectedObservation(
        `#${observations[active].code} - ${observations[active].location}`
      );
      setSelectedObservationId(observations[active].id);
    }
  }, [active]);

  useEffect(() => {
    console.log("room id changes");
    if (selectedRoomId === roomId) {
      console.log("open");
      setIsOpen(true);
    } else {
      console.log("not open");
      setIsOpen(false);
    }
  }, [selectedRoomId]);

  const getObservations = (roomId, page) => {
    setIsLoading(true);
    getRoomObservation(roomId, page)
      .then((x) => {
        console.log(x.data.data);
        if (page === 1) {
          setObservations(x.data.data);
        } else {
          setObservations((state) => [...state, ...x.data.data]);
        }
        if (x.data.data.length > 0 && page === 1) {
          setSelectedObservation(
            "#" + x.data.data[0].code + " - " + x.data.data[0].location
          );
          setSelectedObservationId(x.data.data[0].id);
          setNoData(false);
        } else {
          setNoData(true);
          setSelectedObservationId(null);
          setSelectedObservation("");
        }

        setLastPage(x.data.last_page);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const handleScrollEnd = () => {
    console.log("page", page, "lastPage", lastPage);
    if (page < lastPage) {
      console.log("onscrollyend");
      setPage((page) => page + 1);
    }
  };

  // Handle drag end for observations
  const handleObservationDragEnd = (event) => {
    const { active: activeDrag, over } = event;
    if (activeDrag && over && activeDrag.id !== over.id) {
      const oldIndex = observations.findIndex((o) => o.id === activeDrag.id);
      const newIndex = observations.findIndex((o) => o.id === over.id);
      const newObservations = arrayMove(observations, oldIndex, newIndex);

      // Find the new index of the currently active item after the move
      const currentActiveId = observations[active]?.id;
      const newActiveIndex = newObservations.findIndex(
        (o) => o.id === currentActiveId
      );

      setObservations(newObservations);

      // Update active index to point to the same item at its new position
      if (newActiveIndex !== -1) {
        setActive(newActiveIndex);
      }

      debouncedOrderObservations(newObservations, roomId);
    }
  };

  const handleDeleteObservation = (id) => {
    return (setLoading) => {
      setLoading(true);
      deleteObservation(id)
        .then(() => {
          showToast("Observation deleted successfully", true);
          setLoading(false);
          setRefresh(!refresh);
        })
        .catch((err) => {
          console.log(err);
          showToast(getErrorMsg(err) || "Error deleting observation");
          setLoading(false);
        });
    };
  };

  const handleDeleteObservationRoom = (id) => {
    return (setLoading) => {
      setLoading(true);
      deleteObservationRoom(id)
        .then(() => {
          showToast("Room deleted successfully", true);
          setLoading(false);
          refreshRoomList();
        })
        .catch((err) => {
          console.log(err);
          showToast(getErrorMsg(err) || "Error deleting room");
          setLoading(false);
        });
    };
  };

  const onEditObservation = (item) => {
    setEditObservation({
      location: item.location,
      id: item.id,
    });
    openAddObservationModal();
  };
  return (
    <React.Fragment>
      <li
        className={`room-accordian-style ${
          name?.length > 25 ? "long-name" : ""
        }`}
        id={`room-${roomId}`}
        onClick={() => {
          onOpen && onOpen();
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="d-flex align-items-center">
          {dragListeners && (
            <div
              {...dragListeners}
              style={{
                cursor: "grab",
                display: "flex",
                alignItems: "center",
                marginRight: "8px",
                color: "#74b44a",
              }}
            >
              <DragHandleIcon />
            </div>
          )}
          <span
            className="align-self-center roomName"
            style={{ fontSize: "15px" }}
          >
            {name}
          </span>
          <div
            style={{
              minWidth: "50px",
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
              color: "#84857A",
            }}
          >
            {hovered && <CreateIcon onClick={onEditRoom} />}
            <DeleteButton
              show={hovered}
              deleteFunction={handleDeleteObservationRoom(roomId)}
              message={"Are you sure you want to delete this room?"}
            />
          </div>
        </div>
        <div className="d-flex align-items-center">
          <span
            id={`open_add_observation_${roomId}`}
            className="text-secondary500 me-1 no-wrap obserBtn"
            style={{ whiteSpace: "nowrap" }}
            onClick={(e) => {
              onOpen && onOpen();
              openAddObservationModal();
              e.stopPropagation();
            }}
          >
            + Add Observation
          </span>
          {isOpen ? (
            <ArrowDropUpIcon
              onClick={() => setIsOpen((state) => !state)}
              className="align-self-center text-light50"
              style={{ fontSize: "30px" }}
            />
          ) : (
            <ArrowDropDownIcon
              onClick={() => setIsOpen((state) => !state)}
              className="align-self-center text-light50"
              style={{ fontSize: "30px" }}
            />
          )}
        </div>
      </li>
      {isOpen && !isDragging && (
        <PerfectScrollbar
          style={{ height: "auto" }}
          onYReachEnd={() => handleScrollEnd()}
        >
          <ul className="sub-list">
            {observations.length > 0 ? (
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleObservationDragEnd}
              >
                <SortableContext
                  items={observations.map((o) => o.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {observations.map((item, i) => (
                    <SortableObservation
                      key={item.id}
                      observation={item}
                      index={i}
                      active={active}
                      onEditObservation={onEditObservation}
                      handleDeleteObservation={handleDeleteObservation}
                      setActive={setActive}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            ) : null}
            {noData && (
              <li className="liststyle listActive">No observations created!</li>
            )}
            {isLoading && (
              <div className="center-div">
                <Spinner animation="border" variant="success" />
              </div>
            )}
          </ul>
        </PerfectScrollbar>
      )}
    </React.Fragment>
  );
}
